import { render, staticRenderFns } from "./usermanage.vue?vue&type=template&id=12fe0930&scoped=true"
import script from "./usermanage.vue?vue&type=script&lang=js"
export * from "./usermanage.vue?vue&type=script&lang=js"
import style0 from "./usermanage.vue?vue&type=style&index=0&id=12fe0930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe0930",
  null
  
)

export default component.exports